import React, { useState, useEffect } from 'react';
import "./roadrailpro.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import roadrail1 from "../../../Assets/road-rail-projects.jpg";
import { Link } from 'react-router';
import roadrail2 from "../../../Assets/sound-barrier-india.webp";
import roadrail3 from "../../../Assets/road&rail/walkway-railway.jpg";
import roadrail4 from "../../../Assets/sound-barrier-manufacturer.webp";
import roadrail5 from "../../../Assets/road&rail/road&rail1.jpg";
import roadrail6 from "../../../Assets/road&rail/road&rail2.png";
import roadrail7 from "../../../Assets/road&rail/road&rail3.png";
import roadrail8 from "../../../Assets/road&rail/road&rail4.jpg";
import roadrail9 from "../../../Assets/road&rail/road&rail5.jpg";
import roadrail10 from "../../../Assets/road&rail/road&rail6.jpg";
import roadrail11 from "../../../Assets/road&rail/road&rail7.jpg";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function RoadRailPro() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.rrp-header,.rrp-header1,.rrp-header2,.rrp-header3,.rrp-header4,.rrp-header5,.rrp-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <>
        <HNavbar />
            <section id='road-rail' className='home-road'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-road-rail'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid road-rail-home-img' src={roadrail1} alt="road-rail" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='rrp-header'>Road and Rail Projects Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Road and rail projects generate high levels of continuous noise from vehicles, trains, heavy machinery, and construction equipment. This noise can disturb drivers, nearby residents, shops, and public areas. Sound Barrier Manufacture provides professional sound barrier noise control solutions for road and railway projects.</p>
                            <p className='white-para'>Our sound barrier systems are designed to reduce vehicle and train noise, improve safety, and minimize public disturbance.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >

            <section id='road-rail'>
                <div className='container noice-control mt-4'>
                    <h1 className='rrp-header1'>Why Noise Control is Important in Road and Rail Projects</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={roadrail2} alt="road-rail" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Highway and railway environments produce constant high-decibel noise. Without proper noise barriers, this can cause:</p>
                            <ul className='list'>
                                <li>Driver distraction and discomfort</li>
                                <li>Disturbance to nearby commercial areas</li>
                                <li>Complaints from residential zones</li>
                                <li>Environmental noise regulation issues</li>
                                <li>Safety concerns in construction zones</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing proper road and rail sound barriers helps control noise and improve overall safety.</p>

                    <h1 className='rrp-header2' style={{ marginTop: "10px" }}>Our Road and Rail Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies heavy-duty outdoor sound barrier systems suitable for highways, railways, and infrastructure projects.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Weather-resistant and UV-protected surface</li>
                                <li>Suitable for roadside and railway installations</li>
                                <li>Easy mounting on barricades and fencing</li>
                                <li>Fire-retardant options available</li>
                                <li>Durable and reusable construction</li>
                            </ul>
                            <p>Our acoustic barriers can be installed as temporary barricades or semi-permanent noise control systems.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={roadrail3} alt="road-rail" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='rrp-header3' style={{ marginTop: "30px" }}>Benefits of Road and Rail Noise Barriers</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={roadrail4} alt="road-rail" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Using sound barriers in road and railway projects helps:</p>
                            <ul className='list'>
                                <li>Reduce traffic and train noise</li>
                                <li>Protect drivers from distraction</li>
                                <li>Minimize disturbance to nearby shops and communities</li>
                                <li>Improve construction zone safety</li>
                                <li>Maintain environmental compliance</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='rrp-header4' style={{ marginTop: "20px" }}>Applications in Road and Rail Projects</h1>
                    <h4 className='sub-title mt-3'>Our noise control solutions are ideal for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail5} alt="Highway construction projects" />
                            <p>Highway construction projects</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail6} alt="Railway line construction" />
                            <p>Railway line construction</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail7} alt="Metro rail projects" />
                            <p>Metro rail projects</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail8} alt="Flyover and bridge construction" />
                            <p>Flyover and bridge construction</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail9} alt="Roadside commercial protection" />
                            <p>Roadside commercial protection</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail10} alt="Rail maintenance zones" />
                            <p>Rail maintenance zones</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={roadrail11} alt="Traffic diversion barricades" />
                            <p>Traffic diversion barricades</p>
                        </div>
                    </div>
                </div >
            </section>
            <section id='road-rail' className='call'>
                <div className='container'>
                    <h1 className='rrp-header5'>Why Choose Us?</h1>

                    <ul className='rrp-list white-para'>
                        <li>Experienced infrastructure noise control provider</li>
                        <li>High-performance road and rail sound barriers</li>
                        <li>Custom size and thickness options</li>
                        <li>Quick supply and project support</li>
                        <li>Cost-effective outdoor noise control systems</li>
                    </ul>
                    <p className='white-para'>We provide reliable noise control barricade systems designed to reduce driver disturbance and protect surrounding areas.</p>

                    <h1 className='rrp-header6'>Contact Us for Road and Rail Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for professional noise control systems for road or railway projects?</p>
                            <p className='white-para'>Sound Barrier Manufacture delivers customized sound barrier solutions to reduce vehicle and rail noise while improving safety and public comfort.</p>
                            <p className='white-para'>Contact us today for expert consultation and infrastructure noise control support.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}
export default RoadRailPro